import { getEventCategory } from '../../utils/categories';
import { getCategoryIcon } from '../UI/Icons';

/**
 * CalendarLegend - Shows category color legend (hidden on mobile)
 */
export default function CalendarLegend() {
  const categories = ['flight', 'accommodation', 'transit', 'activity'];
  
  return (
    <div className="hidden md:flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm">
      {categories.map(cat => {
        const category = getEventCategory(cat);
        return (
          <div key={cat} className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded"
              style={{ backgroundColor: `var(--color-category-${category.colorVar})` }}
            />
            <span className="flex items-center gap-1" style={{ color: 'var(--color-text-secondary)' }}>
              {getCategoryIcon(cat, { size: 16, style: { color: 'var(--color-text-muted)' } })}
              {category.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
